// src/components/Layout/GymLayout.tsx
// VERSIÓN ACTUALIZADA CON CONTROL DE SUSCRIPCIÓN

import React from 'react';
import Sidebar from './Sidebar';
import SubscriptionCheck from '../common/SubscriptionCheck';
import { useAuth } from '../../contexts/AuthContext';
import useMonthlyPaymentsAutomation from '../../hooks/useMonthlyPaymentsAutomation';

import { useTheme } from '../../contexts/ThemeContext';

interface GymLayoutProps {
  children: React.ReactNode;
}

const GymLayout: React.FC<GymLayoutProps> = ({ children }) => {
  const { gymData } = useAuth();
  const { isCollapsed } = useTheme();
  
  // 🤖 Activar el scheduler automático
  useMonthlyPaymentsAutomation(gymData?.id, true);
  
  return (
    <div className="flex h-screen bg-gray-100 dark:bg-slate-900 transition-colors">
      <Sidebar />
      
      <div className={`flex-1 ${isCollapsed ? 'md:ml-20' : 'md:ml-64'} transition-all duration-300 overflow-y-auto overflow-x-hidden`}>
        {/* ✅ ENVOLVER CON SubscriptionCheck */}
        <SubscriptionCheck>
          <div className="bg-gray-50 dark:bg-slate-900 min-h-full transition-colors">
            {children}
          </div>
        </SubscriptionCheck>
      </div>
    </div>
  );
};

export default GymLayout;